import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Factory as IntegerMaskFactory} from './IntegerMask/Factory';
import {IntegerMask} from './IntegerMask';

@Component({
    selector: 'telephone-input',
    template: `<div [formGroup]="form">
    <mat-form-field class="full-width tel-input" [class.hide-flag]="hideFlag">
        <mat-label>{{ placeholder }}</mat-label>
        <input #phone
               matInput
               type="text"
               class="form-input"
               [formControlName]="controlName"
               [required]="required"
               ng2TelInput
               [ng2TelInputOptions]="{initialCountry: 'us'}"
               (intlTelInputObject)="onIntlTelInputObject(phone)"
               (countryChange)="onCountryChange($event, phone)"
               (focus)="onFocusTelInput()"
               (blur)="onBlurTelInput(phone)">

        <mat-error *ngIf="hasError(controlName)">Must be required</mat-error>
    </mat-form-field>
</div>

`,
    styles: [`:host /deep/ .tel-input .intl-tel-input{left:15px}:host /deep/ .tel-input .flag-container:hover{display:block!important}:host /deep/ .tel-input.hide-flag:not(.mat-focused) .flag-container{display:none}`]
})
export class TelephoneInputComponent implements OnInit {

    @Input() form: FormGroup;

    @Input() controlName: string;

    @Input() placeholder: string;

    @Input() required: boolean = false;

    // ########################################

    public telephoneInput: FormControl;

    public dialCode: string = '1';

    public telephoneNumber: string = '';

    public hideFlag: boolean = true;

    // ########################################

    private integerMask: IntegerMask = null;

    private integerMaskFactory: IntegerMaskFactory = null;

    // ########################################

    constructor(
        integerMaskFactory: IntegerMaskFactory
    ) {
        this.integerMaskFactory = integerMaskFactory;
    }

    // ########################################

    ngOnInit() {
        this.telephoneInput = new FormControl('', [
            Validators.required
        ]);

        this.form.setControl(this.controlName, this.telephoneInput);
    }

    // ########################################

    public hasError(control: string): boolean {
        return this.form.controls[control].invalid &&
            this.form.controls[control].touched &&
            this.form.controls[control].dirty &&
            this.form.controls[control].errors.required;
    }

    public onIntlTelInputObject(input: HTMLInputElement): void {
        this.integerMask = this.integerMaskFactory.create(input);
    }

    public onCountryChange(country: any, input: HTMLInputElement): void {
        this.dialCode = country.dialCode;

        const format = input.placeholder.replace(/[1-9]/g, '0');

        this.integerMask.updateMask(format);
    }

    public onFocusTelInput(): void {
        this.telephoneInput.setValue(this.telephoneNumber || '');
    }

    public onBlurTelInput(input: HTMLInputElement): void {
        this.telephoneNumber = input.value;

        if (input.value.length === 0) {

            this.hideFlag = true;
        } else {

            this.hideFlag = false;

            const fullPhoneNumber = this.getTelephoneWithDialCode(this.dialCode, this.telephoneNumber);

            this.telephoneInput.setValue(fullPhoneNumber);
        }
    }

    // ########################################

    private getTelephoneWithDialCode(dialCode: string, telephoneNumber: string): string {
        const tel = telephoneNumber.replace(/[^0-9,]/gim, '');

        return `+${dialCode}${tel}`;
    }

    // ########################################
}
